<template>
  <div class="app-wrapper">
    <UPSHeader :is-admin="isAdmin" @showlogout="showLogoutDialog" @modifyPsw="modifyPsw"></UPSHeader>
    <div class="app-content">
      <sidebar class="sidebar-container" :is-admin="isAdmin" @show="showDialog" />
      <div class="main-container">
        <app-main />
      </div>
      <el-dialog :model-value="Eport" title="导出报表" :close-on-click-modal="false" width="30%" height="95%"
        modal-class="export-view dialog-center" @close="clearData">
        <div v-if="Eport" class="export-box">
          <div class="selectExportOption">
            <span class="title">导出项</span>
            <el-radio v-model="exportType" label="1" @change="changeRadio('1')">报关单证</el-radio>
            <el-radio v-model="exportType" label="2" @change="changeRadio('1')">清关异常</el-radio>
          </div>
          <el-form ref="exportForm" :model="exportFormData">
            <div>报关单类型</div>
            <el-form-item>
              <el-select v-model="exportFormData.declarationType" filterable @change="onTypeChange">
                <el-option
                  v-for="(item,index) in declarationTypes"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <div>口岸</div>
            <el-form-item>
              <el-select v-model="exportFormData.port" filterable clearable @change="changePort">
                <el-option
                  v-for="(item,index) in portList"
                  :key="index"
                  :label="item.upsFacilityName"
                  :value="item.declarationSlic">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <div v-if="exportType === '1'">SLIC</div>
            <el-form-item v-if="exportType === '1'">
              <el-select v-model="exportFormData.slic" filterable clearable>
                <el-option
                  v-for="(item,index) in slicList"
                  :key="index"
                  :label="item.upsFacilityName"
                  :value="item.upsFacilitySlic">
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item v-if="exportType === '1'">
              <div>客户</div>
              <el-select-v2
                v-model="exportFormData.username"
                filterable
                clearable
                placeholder="请选择客户"
                :options="profileList"
              />
            </el-form-item>
            <el-form-item>
              <div>进出口标志</div>
              <el-select v-model="exportFormData.shipmentType">
                <el-option
                  v-for="(item,index) in typeList" :key="index"
                  :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <div>报表状态</div>
              <el-select v-model="exportFormData.status">
                <el-option
                  v-for="(item,index) in statusList[exportType]" :key="index"
                  :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <div class="item-lable">时间范围</div>
              <el-radio-group v-model="exportDate" @change="changeDatePick">
                <div class="time-range-box">
                  <el-radio :label="2" calss="time-radio">自定义日期</el-radio>
                  <el-date-picker
                    v-model="dateRange"
                    :disabled="exportDate === 1"
                    :disabled-date="disabledDate"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    class="time-picker"
                    @change="dateChange"
                    @calendar-change="onCalendarChange"
                  >
                  </el-date-picker>
                </div>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <div class="item-lable">排序</div>
              <div class="sort-export">
                <el-radio-group v-model="exportFormData.sort" @change="sortChange">
                  <el-radio v-for="(item, index) in sortList[exportType]" :key="index" :label="item.value">{{ item.label }}
                  </el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item v-if="exportType === '2'">
              <div>导出格式</div>
              <div class="sort-export">
                <el-select v-model="exportExceptionType" clearable>
                  <el-option
                    v-for="(item,index) in exceptionFileType"
                    :key="index"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="show-right">
                <el-button round @click="exportCancel">取消</el-button>
                <el-button round type="primary" @click="submitForm('exportFormData')">确认</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <el-dialog :model-value="logoOutDialogStatus" modal-class="logout-dia" width="25%" :append-to-body="true" align-center @close="logoOutDialogStatus=false">
        <div class="log-out">
          <img src="../assets/img/icon-logout.png" />
          <div class="tip">确认退出系统？</div>
        </div>
        <div class="show-right">
          <el-button round class="log-cancel" @click="logoOutDialogStatus=false">取消</el-button>
          <el-button round type="primary" class="log-confirm" @click="logoOut">确认</el-button>
        </div>
      </el-dialog>
      <el-dialog :model-value="modifyPswDialogStatus" width="25%" title="修改密码" :close-on-click-modal="false">
        <div v-if="modifyPswDialogStatus" class="modify-psw">
          <el-form ref="modifyData" :model="modifyData" :rules="modifyRules">
            <el-form-item label="用户ID" prop="username" class="form-item--square">
              <el-input v-model="modifyData.username" disabled>
              </el-input>
            </el-form-item>
            <el-form-item label="原始密码" prop="oldPassword" class="form-item--square">
              <el-input v-model="modifyData.oldPassword" :type="passwordType">
                <template v-if="modifyData.oldPassword!==undefined && modifyData.oldPassword.length > 0" #suffix>
                  <svg-icon icon-class="eye-open" class="icon--password" @click="changeType('passwordType')" />
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword" class="form-item--square">
              <el-input v-model="modifyData.newPassword" :type="password1Type">
                <template v-if="modifyData.newPassword!==undefined && modifyData.newPassword.length > 0" #suffix>
                  <svg-icon icon-class="eye-open" class="icon--password" @click="changeType('password1Type')" />
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="confirmNewPassword" class="form-item--square">
              <el-input v-model="modifyData.confirmNewPassword" :type="password2Type">
                <template v-if="modifyData.confirmNewPassword!==undefined && modifyData.confirmNewPassword.length > 0"
                  #suffix>
                  <svg-icon icon-class="eye-open" class="icon--password" @click="changeType('password2Type')" />
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <div class="show-right">
                <el-button round @click="modifyPswDialogStatus=false">取消</el-button>
                <el-button round type="primary" @click="confirmModifyPsw">确认</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { AppMain, Sidebar, UPSHeader } from './components'
import { mapState, mapGetters, mapActions } from 'vuex'
import roles from '@/router/roles'
import request from '@/request'
import download from '@/request/download'
import { ElMessage } from 'element-plus'
import { logout } from '@/utils/msal.js'

export default {
  name: 'Layout',
  components: {
    AppMain,
    Sidebar,
    UPSHeader
  },
  // mixins: [ResizeMixin],
  data() {
    const validPass = (rule, value, callback) => {
      const regUppercase = /[A-Z]/.test(value)
      const regLowercase = /[a-z]/.test(value)
      const regNumber = /[0-9]/.test(value)
      const regValid = [regUppercase, regLowercase, regNumber].filter(v => !!v).length > 1
      const lessLength = value.length >= 10
      const moreLength = value.length <= 26
      if (value && (!lessLength || !moreLength || !regValid)) {
        callback(new Error('密码长度在10-26个字符, 需包含大写字母,小写字母, 数字字符任选其三, 且不得包含您的姓名、用户名和邮箱'))
        return
      }
      callback()
    }
    const validPass2 = (rule, value, callback) => {
      const regUppercase = /[A-Z]/.test(value)
      const regLowercase = /[a-z]/.test(value)
      const regNumber = /[0-9]/.test(value)
      const regValid = [regUppercase, regLowercase, regNumber].filter(v => !!v).length > 1
      const lessLength = value.length >= 10
      const moreLength = value.length <= 26
      if (value && (!lessLength || !moreLength || !regValid)) {
        callback(new Error('密码长度在10-26个字符, 需包含大写字母,小写字母, 数字字符任选其三, 且不得包含您的姓名、用户名和邮箱'))
        return
      }
      if (value !== this.modifyData.newPassword) {
        callback(new Error('两次输入密码不一致!'))
        return
      }
      callback()
    }
    return {
      Eport: false,
      isAdmin: false,
      logoOutDialogStatus: false,
      modifyPswDialogStatus: false,
      exportDate: 2,
      exportType: '1',
      declarationTypes: [
        {
          label: '个人物品申报(B类)',
          value: 'B'
        },
        {
          label: '低值货物快件(C类)',
          value: 'C'
        },
        {
          label: '正式申报类货物(D类)',
          value: 'D'
        }
      ],
      exportFormData: {
        declarationType: 'D',
        username: '所有客户',
        port: '所有口岸',
        slic: '所有SLIC',
        shipmentType: '-1',
        status: '-1',
        fromDate: '',
        toDate: '',
        sort: '1'
        // exportType: 0
      },
      exportExceptionType: '所有格式',
      dateRange: [],
      portList: [{
        declarationSlic: '',
        slicInfoList: '',
        upsFacilityName: '所有口岸',
        upsFacilitySlic: ''
      }],
      slicList: [],
      profileList: [],
      exceptionFileType: ['所有格式', 'EXCEL', 'XML'],
      typeList: [
        {
          label: '进口和出口',
          value: '-1'
        }, {
          label: '进口',
          value: '0'
        }, {
          label: '出口',
          value: '1'
        }],
      sortList: {
        1: [{
          label: '口岸',
          value: '1'
        }, {
          label: '客户账号',
          value: '2'
        }, {
          label: '预计取件时间-顺序',
          value: '3'
        }, {
          label: '预计取件时间-倒序',
          value: '4'
        }],
        2: [{
          label: '创建异常时间-顺序',
          value: '1'
        }, {
          label: '创建异常时间-倒序',
          value: '2'
        }]
      },
      /**
       * status.1 是导出报关单 status.2是导出清关异常
         * (0, “草稿”), UNPROCESSED(1, “未处理”), PROCESSED(2, “已审结未完成”), DONE(3, “已完成”), RETURN(4, “退单”), DELETED(5, “删除”)
         */
      statusList: {
        1: [{
          label: '所有状态',
          value: '-1'
        }, {
          label: '草稿',
          value: '0'
        }, {
          label: '未处理',
          value: '1'
        }, {
          label: '已审结未完成',
          value: '2'
        }, {
          label: '已完成',
          value: '3'
        }, {
          label: '单证异常待补充',
          value: '4'
        }, {
          label: '退单未完成',
          value: '10'
        }, {
          label: '退单未提交',
          value: '11'
        }, {
          label: '删除',
          value: '5'
        }],
        2: [{
          label: '所有状态',
          value: '-1'
        }, {
          label: '待处理',
          value: '1'
        }, {
          label: '已通知客户',
          value: '2'
        }, {
          label: '待客户确认',
          value: '3'
        }, {
          label: '待审核',
          value: '4'
        }, {
          label: '已审结',
          value: '6'
        }, {
          label: '作废',
          value: '7'
        }]
      },
      exportRules: {
        portCode: [
          { required: true, message: '请选择口岸', trigger: 'change' }
        ]
      },
      modifyData: {
        'username': undefined,
        'oldPassword': undefined,
        'newPassword': undefined,
        'confirmNewPassword': undefined
      },
      modifyRules: {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'blur' }
        ],
        oldPassword: [
          { required: true, message: '请输入密码', trigger: ['blur'] },
          { validator: validPass, trigger: ['blur'] }
        ],
        newPassword: [
          { required: true, message: '请输入密码', trigger: ['blur'] },
          { validator: validPass, trigger: ['blur'] }
        ],
        confirmNewPassword: [
          { required: true, message: '请输入密码', trigger: ['blur'] },
          { validator: validPass2, trigger: ['blur'] }
        ]
      },
      passwordType: 'password',
      password1Type: 'password',
      password2Type: 'password',
      timer: null,
      selectDate: []
    }
  },
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),
    ...mapGetters({
      userinfo: 'user/userinfo',
      role: 'user/role',
      requestsBeforeLogout: 'user/requestsBeforeLogout'
    })
  },
  created() {
    this.isAdmin = this.role === roles.roleAdmin
    // console.log(this.role, '看一下角色是什么')
    this.modifyData.username = this.userinfo.userName
    if (this.userinfo.isLocked) {
      this.$router.push({ path: '/customers-center/bind' })
      // this.$route.meta.activeMenu = '/customers-center/account'
      this.$bus.$emit('updateActiveMenu', '/customers-center/account/')
    }
  },
  methods: {
    ...mapActions({
      LOGOUT: 'user/LOGOUT'
    }),
    onCalendarChange(val) {
      this.selectDate = val
    },
    disabledDate(time) {
      if (time.getTime() > Date.now()) return true
      if (!this.selectDate.length) return false
      const sd = this.selectDate[0]
      const days = (time.getTime() - sd.getTime()) / (1000 * 60 * 60 * 24)
      return days > 180 || days < -180
    },
    dateChange(val) {
      if (!val) {
        this.selectDate = []
        return
      }
      const beginDate = new Date(val[0])
      const endDate = new Date(val[1])
      const days = (endDate - beginDate) / (1000 * 60 * 60 * 24)
      if (days > 365) {
        this.dateRange = []
        ElMessage({ message: '时间跨度不可以超过一年，请重新选择', type: 'error', grouping: true })
        return
      }
    },
    exportCancel() {
      this.Eport = false
      this.dateRange = []
    },
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    clearData() {
      this.Eport = false
      this.exportFormData = {
        username: '所有客户',
        port: '所有口岸',
        slic: '所有SLIC',
        shipmentType: '-1',
        status: '-1',
        fromDate: '',
        toDate: '',
        sort: '1',
        declarationType: 'D'
        // exportType: 0
      }
      this.exportType = '1'
    },
    getProfileList() {
      request({
        url: '/api/v1/admin/customers',
        method: 'GET',
        params: {
          declarationType: this.exportFormData.declarationType
        }
      }).then(res => {
        const records = Array.isArray(res.records) ? res.records : []
        const list = records.map(item => ({
          value: item.username,
          label: item.companyName || item.username
        }))
        this.profileList = [
          { value: '所有客户', label: '所有客户' },
          ...list
        ]
      })
    },
    getPortListData() {
      request({
        url: '/api/v1/port/slic-info',
        method: 'GET'
      }).then(res => {
        this.portList = [{
          declarationSlic: '所有口岸',
          slicInfoList: '',
          upsFacilityName: '所有口岸',
          upsFacilitySlic: ''
        }]
        this.portList = this.portList.concat(res)
        this.slicList = []
        var slicBean = {
          createBy: '',
          createTime: null,
          declarationSlic: '',
          deleted: undefined,
          id: null,
          updateBy: '',
          updateTime: null,
          upsFacilityName: '所有SLIC',
          upsFacilitySlic: ''
        }
        this.slicList.push(slicBean)
        this.slicList = this.slicList.concat(res[0].slicInfoList)
      })
    },
    onTypeChange() {
      this.exportFormData.username = '所有客户'
      this.exportFormData.port = '所有口岸'
      this.getProfileList()
    },
    changePort(value) {
      if (!value) {
        this.exportFormData = {
          ...this.exportFormData,
          port: '所有口岸'
        }
      }
      this.portList.forEach((item) => {
        if (value === item.declarationSlic) {
          this.slicList.splice(1, this.slicList.length)
          this.slicList = this.slicList.concat(item.slicInfoList)
        }
      })
    },
    changeDatePick(value) {
      // this.slicList = value.slicInfoList
    },
    // typeChange(value) {
    //   console.log('typeChange=>value:', value)
    //   this.exportFormData.exportType = value
    // },
    showDialog(value) {
      if (this.isAdmin) {
        this.getPortListData()
        this.getProfileList()
      }
      this.Eport = value
    },
    showLogoutDialog(value) {
      this.logoOutDialogStatus = true
    },
    sortChange(value) {
      console.log('value:', value)
    },
    submitForm(formData) {
      // exportType 为1的时候是导出报关 2的时候是导出异常
      if (this.exportType === '1') {
        if (this.exportDate === 2) {
          this.exportFormData.fromDate = this.dateRange && this.dateRange.length ? this.dateRange[0] : ''
          this.exportFormData.toDate = this.dateRange && this.dateRange.length ? this.dateRange[1] : ''
        }
        if (this.exportFormData.slic === '所有SLIC') {
          this.exportFormData.slic = ''
        }
        if (this.exportFormData.port === '所有口岸') {
          this.exportFormData.port = ''
        }
        if (this.exportFormData.username === '所有客户') {
          this.exportFormData.username = ''
        }
        if (this.dateRange.length === 0) {
          ElMessage({ message: '请选择自定义日期', type: 'error', grouping: true })
          return
        }
        this.exportOrder()
        // this.$refs[formData].validate((valid) => {
        //   if (valid) {
        //   } else {
        //     return false
        //   }
        // })
      } else {
        if (this.dateRange.length === 0) {
          ElMessage({ message: '请选择自定义日期', type: 'error', grouping: true })
          return
        }
        this.exportException()
      }
    },
    exportOrder() {
      if (this.exportFormData.status === '-1') {
        this.exportFormData.status = ''
      }
      if (this.exportFormData.shipmentType === '-1') {
        this.exportFormData.shipmentType = ''
      }
      download({
        url: '/api/v1/declarations/batch-export',
        method: 'POST',
        data: {
          ...this.exportFormData
        },
        responseType: 'arraybuffer'
      }, { exportTypr: '导出报表', fileType: '.xlsx', declarationType: this.exportFormData.declarationType }).then((res) => {
        if (res.status === 200) {
          this.Eport = false
        }
        if (res.status === 500) {
          ElMessage({ message: res.message, iconClass: 'el-icon-warning-outline', grouping: true })
        }
        this.dateRange = []
      })
    },
    exportException() {
      const copyData = JSON.parse(JSON.stringify(this.exportFormData))
      if (this.exportDate === 2) {
        copyData.fromDate = this.dateRange && this.dateRange.length ? this.dateRange[0] : ''
        copyData.toDate = this.dateRange && this.dateRange.length ? this.dateRange[1] : ''
      }
      const matchType = {
        'EXCEL': {
          code: '01',
          suffix: '.xlsx'
        },
        'XML': {
          code: '02',
          suffix: '.xml'
        },
        '所有格式': {
          code: '03'
        }
      }
      copyData['exportFormat'] = matchType[this.exportExceptionType].code
      delete copyData.slic
      delete copyData.username
      console.log(copyData, 'submit data')
      download({
        url: '/api/v1/clearance/batch-export',
        method: 'POST',
        data: copyData,
        responseType: 'arraybuffer'
      }, {
        exportTypr: '导出报表',
        fileType: matchType[this.exportExceptionType].suffix,
        fileName: `clearance-${new Date().format('MMdd-hhmm')}`
      }).then((res) => {
        if (res.status === 200) {
          this.Eport = false
        }
        this.dateRange = []
      })
    },
    logoOut() {
      this.logoOutDialogStatus = false
      if (this.requestsBeforeLogout) {
        request({
          url: this.requestsBeforeLogout.url,
          method: this.requestsBeforeLogout.method,
          params: this.requestsBeforeLogout.params
        }).then(res => {
          this.realLogout()
        })
      } else {
        this.realLogout()
      }
    },
    realLogout() {
      // 登出
      this.LOGOUT().then(() => {
        let url
        let isClientCLogout
        if (this.role === roles.roleCustomer) {
          url = '/login-c'
          isClientCLogout = true

          this.$router.push({ path: url, query: { isClientCLogout }})
        } else {
          // url = '/login-b'
          logout()
        }
        // this.$router.push({ path: url, query: { isClientCLogout }})
      })
    },
    changeType(field) {
      if (this[field] === 'text') {
        this[field] = 'password'
      } else {
        this[field] = 'text'
      }
    },
    modifyPsw(value) {
      this.modifyPswDialogStatus = true
    },
    confirmModifyPsw() {
      this.$refs.modifyData.validate((valid) => {
        if (valid) {
          request({
            url: '/api/v1/account/password/change',
            method: 'POST',
            data: {
              ...this.modifyData
            }
          }).then(res => {
            ElMessage({ message: '修改成功', grouping: true })
            this.modifyPswDialogStatus = false
            this.logoOut()
          })
        } else {
          return false
        }
      })
    },
    changeRadio(sort) {
      this.exportFormData.port = '所有口岸'
      this.exportFormData.slic = '所有SLIC'
      this.exportFormData.username = '所有客户'
      this.exportFormData.shipmentType = '-1'
      this.exportFormData.status = '-1'
      this.exportFormData.fromDate = ''
      this.exportFormData.toDate = ''
      this.exportFormData.sort = sort
      this.dateRange = []
    }
  }
}
</script>

<style lang="scss">
.el-drawer__title {
  font-size: 16px;
  font-weight: 700;
}
.el-drawer__body {
  padding: 0px;
  overflow: hidden;
}

.logout-dia {
  .el-dialog__body {
    padding: 24px 0px 0px;
  }
}

</style>

<style lang="scss" scoped>
.log-out {
    text-align: center;
    img {
      width: 55px;
      height: 55px;
    }
    .tip {
      font-size: 16px;
      color: #666666;
      margin-top: 20px;
    }
    .log-cancel {
      width: 100px;
      margin-right: 10px
    }
    .log-confirm {
      width: 100px;
    }
  }
  .show-right {
    text-align: right;
    margin-top: 30px;
  }
  .app-wrapper {
    overflow-y: hidden;
    position: relative;
    .scroll-land {
      /*滚动条整体部分,必须要设置*/
      ::-webkit-scrollbar {
        background-color: grey;
        width: 5px;
        height: 10px;
      }
      /*滚动条的轨道*/
      ::-webkit-scrollbar-track {
        background-color: grey;
        border-radius: 10px;
      }
      /*滚动条的滑块按钮*/
      ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #011433;
      }
      div {
        /*滚动条滑块按钮的颜色*/
        scrollbar-face-color: grey;
        /*滚动条整体颜色*/
        scrollbar-highlight-color: grey;
        /*滚动条轨道颜色*/
        scrollbar-track-color: grey;
      }
    }
    .export-view {
      width: 100%;
      height: 90%;
      overflow-y: auto;
      .el-form {
        margin: 0 10px !important;
      }
      .el-dialog__header {
        padding: 20px 30px;
        padding-bottom: 10px;
      }
      .el-select {
        display: inline-block;
        position: relative;
        width: 100%;
      }
      .show-right {
        text-align: right;
        margin-top: 10px;
      }
      .sort-export {
        width: 100%;
        .el-radio-group {
          display: flex !important;
          flex-direction: row;
          flex-wrap: wrap;
          line-height: 1;
          vertical-align: middle;
          font-size: 0;

          .el-radio {
            color: #606266;
            font-weight: 500;
            line-height: 1;
            position: relative;
            cursor: pointer;
            display: inline-block;
            white-space: nowrap;
            outline: none;
            width: 40%;
            margin-bottom: 10px;
            font-size: 12px;
            margin-right: 30px;
            -moz-user-select: none;
            -webkit-user-select: none;
            -ms-user-select: none;
          }
        }
      }
      .el-dialog__body {
        padding: 20px 20px;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
      }
      .export-box {
        margin: 12px 0px;
        height: 550px;
        overflow-y: auto
      }
      .item-lable {
        margin-bottom: 10px;
      }
      .time-range-box {
        margin-top: 10px;
      }
      .time-radio {
        display: inline-block
      }
      .time-picker {
        width: 60%;
      }
    }
    .log-out {
      text-align: center;
      img {
        width: 55px;
        height: 55px;
      }
      .tip {
        font-size: 16px;
        color: #666666;
        margin-top: 20px;
      }
      .log-cancel {
        width: 100px;
        margin-right: 10px
      }
      .log-confirm {
        width: 100px;
      }
    }
    .modify-psw {
      .form-item--square {
        margin-top: 0px;
      }
      .icon--password {
        width: 22px;
        height: 15px;
        // color: $blue;
        cursor: pointer;
      }
    }
    .show-right {
      width: 100%;
      text-align: right;
      margin-top: 40px;
    }
    .selectExportOption {
      padding: 0 10px 20px 10px;
    }
    .selectExportOption .title {
      display: block;
      margin-bottom: 15px;
    }
  }
</style>
